import React from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import classes from "./PageHeading.module.css";

const PageHeading = ({ title, description }) => {
    if (!title && !description) {
        return null;
    }

    return (
        <div className={classes.topSection}>
            <Typography variant="h3">{title}</Typography>
            <Typography className={classes.description}>{description}</Typography>
        </div>
    );
};

PageHeading.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
};

export default PageHeading;
